import { Avatar, Stack, SxProps, Theme, Typography } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";

import { GaiaSubtleLink } from "~/modules/app/components/GaiaSubtleLink";

type Props = {
    profilePicture?: string | null;
    names?: string[];
    showName?: boolean;
    size?: number;
    sx?: SxProps<Theme>;
    nameTextVariant?: Variant;
    linkTo?: string;
};

export default function UserBadge({
    profilePicture,
    names = [],
    showName = false,
    size = 40,
    sx = { marginLeft: 0, height: "100%" },
    nameTextVariant = "body2",
    linkTo,
}: Props) {
    const initials = names
        .filter(i => !!i)
        .map(i => i[0])
        .join("");

    const content = (
        <Stack direction="row" spacing={0.5} alignItems="center" sx={sx}>
            <Avatar src={profilePicture ?? undefined} alt={initials} sx={{ width: size, height: size, fontSize: size / 2 }}>
                {!profilePicture && initials}
            </Avatar>
            {showName && <Typography variant={nameTextVariant}>{names.join(" ")}</Typography>}
        </Stack>
    );

    return linkTo ? <GaiaSubtleLink to={linkTo}>{content}</GaiaSubtleLink> : content;
}
